
export const mainbasic = {

  stafflevel: {
    service:{
      name:'stafflevel',
      title:'Staff Level',
    }
  },

  staffrole: {
    service:{
      name:'staffrole',
      title:'Staff Role',
    }
  },

  stafftype: {
    service: {
      name: 'stafftype',
      title: 'Staff Type',
    }
  },

  unitcat: {
    service:{
      name:'unitcat',
      title:'Unit Category',
    }
  },

  unitclass: {
    service:{
      name:'unitclass',
      title:'Unit Class',
    }
  },

  unitgroup: {
    service:{
      name:'unitgroup',
      title:'Unit Group',
    }
  },

  unittype: {
    service:{
      name:'unittype',
      title:'Unit Type',
    }
  },

  // transactionstatus: {
  //   service:{
  //     name:'transactionstatus',
  //     title:'Transaction Status',
  //   }
  // },

  // transactiontype: {
  //   service:{
  //     name:'transactiontype',
  //     title:'Transaction Type',
  //   }
  // },

};
